export enum ChallengeType {
    TIME_CHALLENGE = "Time Challenge"
}